import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { createTransform } from 'redux-persist';

import authSlice from './slices/authSlice';
import userSlice from './slices/userSlice';
import uiSlice from './slices/uiSlice';
import themeSlice from './slices/themeSlice';
import dashboardSlice from './slices/dashboardSlice';
import reduxState from './reduxState';
import warehouseSlice from './slices/warehouseSlice';
import auditLogSlice from './slices/auditLogSlice';
import productSlice from './slices/productSlice';
import inventorySlice from './slices/inventorySlice';

/**
 * 🔐 Persist hanya data auth penting
 */
const authTransform = createTransform(
    // inbound (save)
    (inboundState) => ({
        accessToken: inboundState.accessToken,
        refreshToken: inboundState.refreshToken
    }),
    // outbound (rehydrate)
    (outboundState) => ({
        ...outboundState
    }),
    { whitelist: ['reduxState'] }
);

const rootReducer = combineReducers({
    auth: authSlice,
    auditLog: auditLogSlice,
    users: userSlice,
    ui: uiSlice,
    theme: themeSlice,
    dashboard: dashboardSlice,
    warehouse: warehouseSlice,
    product: productSlice,
    inventory: inventorySlice,
    reduxState
});

const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['reduxState'],
    transforms: [authTransform],
    version: 1
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
            }
        })
});

export const persistor = persistStore(store);
